import React from 'react';

function ArchiveIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M15.499,2.036 L14.35,0.647 C14.023,0.236 13.531,0 13,0 L3,0 C2.476,0 1.982,0.233 1.646,0.641 L0.504,2.033 C0.179,2.413 0,2.904 0,3.417 L0,13.833 C0,15.028 0.972,16 2.167,16 L13.833,16 C15.028,16 16,15.028 16,13.833 L16,3.417 C16,2.906 15.822,2.416 15.499,2.036 Z M15,13.833 C15,14.477 14.477,15 13.833,15 L2.167,15 C1.523,15 1,14.477 1,13.833 L1,3.417 C1,3.143 1.094,2.882 1.271,2.676 L2.419,1.277 C2.565,1.098 2.772,1 3,1 L13,1 C13.228,1 13.429,1.096 13.572,1.276 L14.73,2.676 C14.732,2.678 14.734,2.681 14.736,2.683 C14.906,2.882 15,3.143 15,3.417 L15,13.833 Z"
      />
      <path
        d="M9.393,10.169 L8.5,11.18 L8.5,5.5 C8.5,5.224 8.276,5 8,5 C7.724,5 7.5,5.224 7.5,5.5 L7.5,11.18 L6.607,10.169 C6.421,9.959 6.106,9.942 5.901,10.125 C5.694,10.309 5.674,10.624 5.857,10.831 L7.625,12.831 C7.721,12.938 7.856,13 8,13 C8.144,13 8.279,12.938 8.375,12.831 L10.143,10.831 C10.326,10.624 10.306,10.309 10.099,10.125 C9.893,9.942 9.577,9.959 9.393,10.169 Z"
      />
      <path
        d="M13.475,2.475 L2.533,2.475 C2.257,2.475 2.033,2.699 2.033,2.975 C2.033,3.251 2.257,3.475 2.533,3.475 L13.474,3.475 C13.75,3.475 13.974,3.251 13.974,2.975 C13.974,2.699 13.751,2.475 13.475,2.475 Z"
      />
    </svg>
  );
}

export default ArchiveIcon;
